import React, { memo, useMemo } from 'react';

import visitorFieldNames from './VisitorFieldNames';

const StaticVisitorFields = () => {
    const fields = useMemo(
        () => visitorFieldNames.map((name) => <input key={name} type="hidden" name={name} className="dynamics-hidden-field" />),
        [],
    );

    return <>{fields}</>;
};

export default memo(StaticVisitorFields);
